import React from "react";

interface LinkModalProps {
  isOpen: boolean;
  linkUrl: string;
  linkText: string;
  onLinkUrlChange: (value: string) => void;
  onLinkTextChange: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
}

export const LinkModal: React.FC<LinkModalProps> = ({
  isOpen,
  linkUrl,
  linkText,
  onLinkUrlChange,
  onLinkTextChange,
  onSubmit,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Insert Link</h3>
        <div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">URL</label>
            <input
              type="url"
              value={linkUrl}
              onChange={(e) => onLinkUrlChange(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onSubmit()}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-main/20 focus:border-primary-main"
              placeholder="https://example.com"
              autoFocus
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Text (optional)</label>
            <input
              type="text"
              value={linkText}
              onChange={(e) => onLinkTextChange(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onSubmit()}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-main/20 focus:border-primary-main"
              placeholder="Link text"
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50 transition-all"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSubmit}
              className="px-4 py-2 bg-primary-main text-white rounded-md text-sm font-medium hover:bg-primary-main/90 transition-all"
            >
              Insert Link
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


